import { useEffect } from 'react'

import { Loader } from '@mantine/core'

import { useQuery } from '@redwoodjs/web'

import DNButton from 'src/components/Buttons/Button/DNButton'
import { useTaskModalContext } from 'src/context/TaskModalContext'
import { GET_TASKS } from 'src/graphql/tasks.graphql'
import { TaskStatus } from 'src/graphql/types/tasks'
import SimplifiedTaskRow from 'src/pages/DashboardPage/components/SimplifiedTaskRow'

const TaskTab = ({ applicant }) => {
  const { registerRefetch, handleOpen } = useTaskModalContext()
  const { data, loading, refetch } = useQuery(GET_TASKS, {
    variables: {
      pageInfo: {
        limit: 100,
        offset: 0,
      },
      filters: {
        status: [
          TaskStatus.NOT_STARTED,
          TaskStatus.IN_PROGRESS,
          TaskStatus.COMPLETED,
        ],
        applicantId: applicant.applicantId,
      },
    },
  })
  const tasks = data?.tasks?.items || []

  // Register handleRefetch with the context
  useEffect(() => {
    const handleRefetch = () => {
      refetch()
    }
    registerRefetch(handleRefetch)
  }, [registerRefetch, refetch])

  return (
    <div className={`flex flex-1 flex-col gap-2 overflow-hidden`}>
      {tasks.length === 0 && !loading ? (
        <div className="flex flex-1 flex-col items-center justify-center text-xs text-doubleNickel-gray-500">
          No tasks found
        </div>
      ) : (
        <>
          {loading ? (
            <div className="flex flex-1 flex-col items-center justify-center">
              <Loader size="xs" color="gray" />
            </div>
          ) : (
            <div className="flex flex-1 flex-col overflow-auto">
              {tasks.map((task) => (
                <SimplifiedTaskRow
                  key={task.id}
                  task={task}
                  showApplicantLink={false}
                />
              ))}
            </div>
          )}
        </>
      )}
      <DNButton variant="secondary" onClick={() => handleOpen({ applicant })}>
        Add task
      </DNButton>
    </div>
  )
}

export default TaskTab
